/* override functions api.jquery.js */

window.jQuery.fn.serializeObjectZookal = function () {
  var o = {};
  var a = this.serializeArray();
  $.each(a, function () {
    if (o[this.name]) {
      if (!o[this.name].push) {
        o[this.name] = [o[this.name]];
      }
      o[this.name].push(this.value || '');
    } else {
      o[this.name] = this.value || '';
    }
  });
  return o;
};

var formatMoney = "<span class='money'>${{amount}}</span>";

Shopify.onItemAdded = function (line_item) {
  Shopify.getCart();
};

Shopify.onCartUpdate = function (cart) {
  Shopify.cartUpdateInfo(cart, '.single-cart-item-loop');
};

Shopify.onError = function (XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    var str = data.description;
  } else {
    var str = 'Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.';
  }
  jQuery('.error_message').text(str);
  jQuery('#modalAddToCartError').modal("toggle");
  setTimeout(function () {
    jQuery('.shopping__cart').removeClass("shopping__cart__on");
    jQuery('.body__overlay').removeClass("is-visible");
  }, 2000);
}

Shopify.addItem = function (variant_id, quantity, callback) {
  var quantity = quantity || 1;
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: 'quantity=' + quantity + '&id=' + variant_id,
    dataType: 'json',
    success: function (line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item);
      } else {
        Shopify.cartPopap(variant_id);
        Shopify.onItemAdded(line_item);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

var subscriptionProductParams = {
  id: hh_subscription_variant_id,
  quantity: 1,
  variant_id: hh_subscription_variant_id,
  properties: {
    shipping_interval_unit_type: 'Months',
    shipping_interval_frequency: 1
  }
}

Shopify.addItemFromForm = function (form_id, variant_id, callback) {
  var hh_radio_element = jQuery(`input[type="radio"][name="cb_homework_subscription_${variant_id}"]`)
  var addHomeworkSubscription = jQuery(`input[type="radio"][name="cb_homework_subscription_${variant_id}"]:checked`).val() === "1"

  var serializedArr = jQuery('#' + form_id).serializeObjectZookal()
  var items = [serializedArr]
  if (addHomeworkSubscription) {
    window.hh_subscription_added = true
    if (!cart_contains_subscriptions && !is_user_subscribed) {
      items.push(subscriptionProductParams)
    }
  }
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    beforeSend: function () {
      if (form_id == "add-item-qv") {
        jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_wait").html());
      }
    },
    data: {
      items
    },
    dataType: 'json',
    success: function (line_items) {
      if (line_items.items.find(line_item => line_item.sku.includes('sub-premium'))) {
        cart_contains_subscriptions = true
      }
      if ((typeof callback) === 'function') {
        callback(line_items);
      } else {
        if (form_id != "add-item-qv") {
          Shopify.cartPopupForm(variant_id, line_items.items);
        } else {
          jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_added").html());
          jQuery('#' + form_id).find(".addtocartqv").addClass("added_in_cart");
          setTimeout(function () {
            jQuery('#' + form_id).find(".addtocartqv").removeClass("added_in_cart");
            jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
          }, 2000);
        }
        Shopify.onItemAdded(line_items);
        $('#Textbook-AddToCart').attr('disabled', false);
        $('#eTextbook-AddToCart').attr('disabled', false);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      if (form_id != "add-item-qv") {
        Shopify.onError(XMLHttpRequest, textStatus);
      } else {
        jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_error").html());
        jQuery('#' + form_id).find(".addtocartqv").addClass("error_in_cart");
        setTimeout(function () {
          jQuery('#' + form_id).find(".addtocartqv").removeClass("error_in_cart");
          jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
        }, 2000);
      }
      Shopify.onItemAdded(line_item);
    }
  };
  jQuery.ajax(params);
};

/* user functions */

Shopify.addItemFromFormStart = function (form, product_id) {
  Shopify.addItemFromForm(form, product_id);
}

Shopify.cartPopap = function (variant_id) {
  var image = jQuery('[data-variant-id=' + variant_id + '] .ais-hit--picture').css('background-image').replace('url(', '').replace(')', '').replace(/\"/gi, "");
  var title = jQuery('[data-variant-id=' + variant_id + '] .ais-hit--details .ais-hit--title a').text();
  jQuery('.popupimage').attr("src", '' + image + '');
  jQuery('.productmsg').text('' + title + '');
  jQuery('#modalAddToCart').modal("toggle");
}

Shopify.cartPopupForm = function (variant_id, line_items) {
  var zookalStudyLineItem = line_items.find(line_item => line_item.sku.includes('sub-premium'));
  var primaryLineItem = line_items.find(line_item => line_item.id === variant_id);
  var image = jQuery('.product_variant_image').attr("src");
  var authors = jQuery('.authors').text();
  var isbn = jQuery('.isbn-value').text();

  jQuery('.popupimage').attr("src", '' + image + '');

  var {price, compareAtPrice} = $('.product-detail-tabs .tab.active').data();
  if (typeof price == 'string') {
    price = parseFloat(price.replace(',', ''))
  }
  if (typeof compareAtPrice == 'string') {
    compareAtPrice = parseFloat(compareAtPrice.replace(',', ''))
  }

  var discount = compareAtPrice - price

  let productMsgHtml = `
    <div class="title text-emphasis">${primaryLineItem.title}</div>
    <div class="authors">${authors}</div>
    <div class="isbn">ISBN:&nbsp;${isbn}</div>    
    <div class="has-discount">
      ${discount != 0 ? `<span class="original-price">${Shopify.formatMoney(compareAtPrice * 100, formatMoney)}</span>` : ''}
      ${discount != 0 ? `<span class="savings">&nbsp;Saved ${Shopify.formatMoney(discount * 100, formatMoney)}</span>` : ''}
    </div>
    <div class="price final-price text-emphasis">${Shopify.formatMoney(price * 100, formatMoney)}</div>
  `

  jQuery('.productmsg').html(productMsgHtml);
  jQuery('.save-with-zs').html(Shopify.formatMoney(price * hh_discount_percentage  * 100, formatMoney))
  jQuery('#modalAddToCart').modal("toggle");
  refreshProductSubOption({cartContainsSubscription: zookalStudyLineItem !== undefined || cart_contains_subscriptions})
}

Shopify.cartUpdateInfo = function (cart, cart_cell_id) {
  if ((typeof cart_cell_id) === 'string') {
    var cart_cell = jQuery(cart_cell_id);
    if (cart_cell.length) {
      cart_cell.empty();
      jQuery.each(cart, function (key, value) {
        if (key === 'items') {

          if (value.length > 0) {
            jQuery(".single-product-cart, .item-multiple-item-count").css({"display": "block"});
            jQuery(".cart-empty-title,  .item-single-item-count").css({"display": "none"});

            var table = jQuery(cart_cell_id);
            jQuery.each(value, function (i, item) {
              if (i > 19) {
                return false;
              }
              if (item.sku.includes('sub-premium')) {
                jQuery('<li class="single-shopping-cart"><div class="shopping-cart-img"><img src="' + item.image + '" alt="{{ item.img.alt }}" style="width: 90px;"></div><div class="shopping-cart-details"><div class="shopping-cart-title"><h4>' + item.title?.replace('- Subscription', '') + '</h4><span>' + item.quantity + ' x ' + Shopify.formatMoney(item.price, formatMoney) + '</span></div><div class="item-close"><a href="javascript:void(0);" data-variant-id="' + item.variant_id + '" id="remove-item-' + item.sku + '" class="remove-zookal-study-item">Remove</a></div></div></li>').appendTo(table);
                window.hh_subscription_product_price = parseFloat(item.price)
              } else {
                var item_price = item.price
                jQuery('<li class="single-shopping-cart"><div class="shopping-cart-img"><a href="' + item.url + '"><img src="' + item.image + '" alt="{{ item.img.alt }}" style="width: 90px;"></a></div><div class="shopping-cart-details"><div class="shopping-cart-title"><h4><a href="' + item.url + '">' + item.title + '</a></h4><span>' + item.quantity + ' x ' + Shopify.formatMoney(item_price, formatMoney) + '</span></div><div class="item-close"><a href="javascript:void(0);" onclick="Shopify.removeItem(' + item.variant_id + ', function(){ location.reload(); })" id="remove-item-' + item.sku + '">Remove</a></div></div></li>').appendTo(table);
              }

            });
          } else {
            jQuery(".single-product-cart, .item-single-item-count").css({"display": "none"});
            jQuery(".cart-empty-title").css({"display": "block"});
          }
        }
      });


    }
  }

  var cart_total_price = cart.total_price
  var cart_total_price_without_hh_product_price = parseFloat(cart.total_price) - parseFloat(window.hh_subscription_product_price)
  var hh_discount_total_price = parseFloat(window.hh_discount_percentage) * cart_total_price_without_hh_product_price
  var cart_total_price_with_discounts = (cart_total_price_without_hh_product_price - parseFloat(hh_discount_total_price)) + parseFloat(window.hh_subscription_product_price)

  changeHtmlValue(".shopping-cart__total", Shopify.formatMoney(cart_total_price, formatMoney));
  changeHtmlValue(".bigcounter", cart.item_count);

  changeHtmlValue("#modalAddZookalStudyToCart .price-with-zookal-study", Shopify.formatMoney(cart_total_price_with_discounts, formatMoney));
  changeHtmlValue("#modalAddZookalStudyToCart .price-without-zookal-study", Shopify.formatMoney(cart_total_price, formatMoney));
  changeHtmlValue("#modalAddZookalStudyToCart .discounted-price-with-zookal-study", Shopify.formatMoney(hh_discount_total_price, formatMoney));

  changeHtmlValue("#modalRemoveZookalStudyFromCart .price-with-zookal-study", Shopify.formatMoney(cart_total_price_with_discounts, formatMoney));
  changeHtmlValue("#modalRemoveZookalStudyFromCart .price-without-zookal-study", Shopify.formatMoney(cart_total_price, formatMoney));
  changeHtmlValue("#modalRemoveZookalStudyFromCart .discounted-price-with-zookal-study", Shopify.formatMoney(hh_discount_total_price, formatMoney));

  jQuery('.currency .active').trigger('click');
}

$(document).on('click', '#add-zookal-study', (event) => {
  var targetElement = $(event.target)
  $('#add-zookal-study').hide()
  $('.add-zookal-study-loader').show()
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: {
      items: [
        subscriptionProductParams
      ]
    },
    dataType: 'json',
    success: function (line_items) {
      location.reload()
    },
    error: function (XMLHttpRequest, textStatus) {
      $('.add-zookal-study-loader').hide();
    }
  };
  jQuery.ajax(params);
})

//Utils
function changeHtmlValue(cell, value) {
  var $cartLinkText = jQuery(cell);
  $cartLinkText.html(value);
}
